var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 115,
    viewBox: "0 0 154 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b0bec5;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.825 24)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 54,
    rx: 6,
    transform: "translate(0.175 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 53,
    rx: 6,
    transform: "translate(26.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 53,
    rx: 6,
    transform: "translate(52.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 53,
    rx: 6,
    transform: "translate(77.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 67,
    rx: 6,
    transform: "translate(103.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 67,
    rx: 6,
    transform: "translate(129.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 154,
    height: 115,
    transform: "translate(-1.825 -24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStep4);
export default __webpack_public_path__ + "static/media/img_step4.482fb54710c10865ce4339423e08ce55.svg";
export { ForwardRef as ReactComponent };